 (function () {
  'use strict';

  // Small utilities
  function debounce(fn, wait) { let t; return function (...a) { clearTimeout(t); t = setTimeout(() => fn.apply(this, a), wait); }; }

  function loadSwiperFromCDN() {
    return new Promise((resolve, reject) => {
      if (typeof Swiper !== 'undefined') return resolve();
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
      document.head.appendChild(link);
      const script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  // Apply width based on mode (percent/px/auto)
  function applyWidthForBlock(block, isMobile) {
    const mode = isMobile ? (block.dataset.widthModeMobile || block.dataset.widthMode) : (block.dataset.widthMode || 'percent');
    const px = isMobile ? (block.dataset.widthPxMobile || block.dataset.widthPx) : block.dataset.widthPx;
    const percentField = block.classList.contains('slide-text-block') ? (isMobile ? block.dataset.textWidthMobile : block.dataset.textWidth) : (isMobile ? block.dataset.blockWidthMobile : block.dataset.blockWidth) || (isMobile ? block.dataset.imageWidthMobile : block.dataset.imageWidth);
    if (mode === 'px' && px) {
      block.style.width = px + 'px';
      block.style.display = '';
    } else if (mode === 'auto') {
      block.style.width = 'auto';
      block.style.display = 'inline-block';
    } else if (percentField) {
      block.style.width = percentField + '%';
      block.style.display = '';
    }
  }

  // Apply transform based on anchor point
  function applyAnchorTransform(block) {
    const anchor = block.dataset.anchorPoint || 'top-left';
    let transformX = '0';
    let transformY = '0';
    
    if (anchor === 'center') {
      transformX = '-50%'; transformY = '-50%';
    } else if (anchor === 'top-center') {
      transformX = '-50%';
    } else if (anchor === 'bottom-center') {
      transformX = '-50%'; transformY = '-100%';
    } else if (anchor === 'center-left') {
      transformY = '-50%';
    } else if (anchor === 'center-right') {
      transformX = '-100%'; transformY = '-50%';
    } else if (anchor === 'top-right') {
      transformX = '-100%';
    } else if (anchor === 'bottom-left') {
      transformY = '-100%';
    } else if (anchor === 'bottom-right') {
      transformX = '-100%'; transformY = '-100%';
    }
    
    block.style.transform = `translate(${transformX}, ${transformY})`;
  }

  function applyMobileOverrides(wrapper) {
    const isMobile = window.innerWidth <= 768;
    const slides = wrapper.querySelectorAll('.jam-slide');
    slides.forEach(slide => {
      const inner = slide.querySelector('.slide-content-inner');
      if (inner) {
        if (isMobile) {
          if (slide.dataset.contentPaddingTopMobile) inner.style.paddingTop = slide.dataset.contentPaddingTopMobile + 'px';
          if (slide.dataset.contentPaddingBottomMobile) inner.style.paddingBottom = slide.dataset.contentPaddingBottomMobile + 'px';
          if (slide.dataset.contentPaddingHorizontalMobile) { inner.style.paddingLeft = slide.dataset.contentPaddingHorizontalMobile + 'px'; inner.style.paddingRight = slide.dataset.contentPaddingHorizontalMobile + 'px'; }
        } else {
          inner.style.paddingTop = '';
          inner.style.paddingBottom = '';
          inner.style.paddingLeft = '';
          inner.style.paddingRight = '';
        }
      }

      const overlay = slide.querySelector('.slide-overlay');
      if (overlay) {
        if (isMobile && slide.dataset.overlayOpacityMobile !== undefined) {
          overlay.style.opacity = ((parseFloat(slide.dataset.overlayOpacityMobile) || 0) / 100).toString();
        } else {
          overlay.style.opacity = '';
        }
      }

      const blocks = slide.querySelectorAll('.slide-text-block, .slide-image-block, .slide-html-block');
      blocks.forEach(block => {
        if (isMobile) {
          if (block.dataset.positionTopMobile !== undefined && block.dataset.positionTopMobile !== '') block.style.top = block.dataset.positionTopMobile + '%';
          if (block.dataset.positionLeftMobile !== undefined && block.dataset.positionLeftMobile !== '') block.style.left = block.dataset.positionLeftMobile + '%';
          applyWidthForBlock(block, true);
          if (block.classList.contains('slide-text-block')) {
            const h = block.querySelector('.slide-text-heading');
            const s = block.querySelector('.slide-text-subtitle');
            if (h && block.dataset.fontSizeMobile) h.style.fontSize = block.dataset.fontSizeMobile + 'px';
            if (s && block.dataset.subFontSizeMobile) s.style.fontSize = block.dataset.subFontSizeMobile + 'px';
          }
          applyAnchorTransform(block);
        } else {
          // Restaurar valores desktop originales
          if (block.dataset.positionTop !== undefined && block.dataset.positionTop !== '') {
            block.style.top = block.dataset.positionTop + '%';
          }
          if (block.dataset.positionLeft !== undefined && block.dataset.positionLeft !== '') {
            block.style.left = block.dataset.positionLeft + '%';
          }
          applyWidthForBlock(block, false);
          // NO limpiar font sizes - los inline styles del Liquid son correctos
          applyAnchorTransform(block);
        }
      });
    });

    // Global pagination/arrows visibility and styling from section-level (wrapper) dataset
    const pagination = wrapper.querySelector('.jam-slideshow-pagination');
    const prev = wrapper.querySelector('.swiper-button-prev');
    const next = wrapper.querySelector('.swiper-button-next');
    const isMob = window.innerWidth <= 768;
    
    if (pagination) {
      // NO manipular display - dejar que CSS maneje la visibilidad completamente
      // position override
      const bulletsPosMobile = wrapper.dataset.bulletsPositionMobile || wrapper.dataset.bulletsPosition;
      if (isMob && bulletsPosMobile) {
        pagination.className = 'swiper-pagination jam-slideshow-pagination ' + bulletsPosMobile;
      }
    }
    
    if (prev && next) {
      // NO manipular display - dejar que CSS maneje la visibilidad completamente

      // size / offset / bg / color overrides from wrapper
      const arrowsSizeMobile = wrapper.dataset.arrowsSizeMobile || wrapper.dataset.arrowsSize;
      const arrowsOffsetMobile = wrapper.dataset.arrowsOffsetMobile || wrapper.dataset.arrowsOffset;
      const arrowsBgMobile = wrapper.dataset.arrowsBgMobile || wrapper.dataset.arrowsBg;
      const arrowsColorMobile = wrapper.dataset.arrowsColorMobile || wrapper.dataset.arrowsColor;
      const arrowsPosMobile = wrapper.dataset.arrowsPositionMobile || wrapper.dataset.arrowsPosition;

      if (arrowsSizeMobile) {
        prev.style.width = arrowsSizeMobile + 'px'; prev.style.height = arrowsSizeMobile + 'px';
        next.style.width = arrowsSizeMobile + 'px'; next.style.height = arrowsSizeMobile + 'px';
        prev.style.setProperty('--arrow-size', arrowsSizeMobile + 'px');
        next.style.setProperty('--arrow-size', arrowsSizeMobile + 'px');
        prev.style.setProperty('--arrow-icon-size', Math.round(parseInt(arrowsSizeMobile) * 0.6) + 'px');
        next.style.setProperty('--arrow-icon-size', Math.round(parseInt(arrowsSizeMobile) * 0.6) + 'px');
      }
      if (arrowsOffsetMobile) {
        if (arrowsPosMobile && arrowsPosMobile.indexOf('bottom') === 0) {
          prev.style.bottom = arrowsOffsetMobile + 'px'; next.style.bottom = arrowsOffsetMobile + 'px';
        } else {
          prev.style.left = arrowsOffsetMobile + 'px'; next.style.right = arrowsOffsetMobile + 'px';
        }
      }
      if (arrowsBgMobile) { prev.style.background = arrowsBgMobile; next.style.background = arrowsBgMobile; }
      if (arrowsColorMobile) { prev.style.color = arrowsColorMobile; next.style.color = arrowsColorMobile; }
    }
  }

  function initSlideshows() {
    if (typeof Swiper === 'undefined') { setTimeout(initSlideshows, 100); return; }
    const wrappers = document.querySelectorAll('.jam-slideshow-wrapper');
    wrappers.forEach(wrapper => {
      const swiperEl = wrapper.querySelector('.jam-slideshow-swiper');
      if (!swiperEl) return;

      // Prevenir re-inicialización si ya existe un swiper
      if (swiperEl.swiper && typeof swiperEl.swiper.destroy === 'function') {
        return; // Ya está inicializado, no hacer nada
      }

      // Contar slides reales (no duplicados por Swiper)
      const realSlidesCount = swiperEl.querySelectorAll('.swiper-slide').length;

      const config = {
        autoplay: wrapper.dataset.autoplay === 'true',
        autoplaySpeed: parseInt(wrapper.dataset.autoplaySpeed) || 5000,
        loop: wrapper.dataset.loop === 'true' && realSlidesCount > 1, // Solo loop si hay más de 1 slide
        showBullets: wrapper.dataset.showBullets === 'true',
        showBulletsMobile: wrapper.dataset.showBulletsMobile === 'true',
        showArrows: wrapper.dataset.showArrows === 'true',
        showArrowsMobile: wrapper.dataset.showArrowsMobile === 'true',
        arrowsSize: parseInt(wrapper.dataset.arrowsSize) || 50,
        arrowsOffset: parseInt(wrapper.dataset.arrowsOffset) || 20,
        arrowsBg: wrapper.dataset.arrowsBg || '#fff',
        arrowsColor: wrapper.dataset.arrowsColor || '#000',
        heightMode: wrapper.dataset.heightMode || 'auto',
        fixedHeight: parseInt(wrapper.dataset.fixedHeight) || 600,
        transitionSpeed: parseInt(wrapper.dataset.transitionSpeed) || 600,
        effect: wrapper.dataset.effect || 'slide'
      };

      // Solo aplicar overrides si estamos en mobile al cargar
      const isMobileOnLoad = window.innerWidth <= 768;
      if (isMobileOnLoad) {
        applyMobileOverrides(wrapper);
      }

      // set CSS vars for arrows
      try {
        wrapper.style.setProperty('--arrow-size', (config.arrowsSize || 50) + 'px');
        wrapper.style.setProperty('--arrow-icon-size', Math.round((config.arrowsSize || 50) * 0.6) + 'px');
        wrapper.style.setProperty('--arrow-bg', config.arrowsBg);
        wrapper.style.setProperty('--arrow-color', config.arrowsColor);
      } catch (e) { /* ignore */ }

      // Obtener elementos directamente del DOM del wrapper
      const paginationEl = wrapper.querySelector('.swiper-pagination');
      const nextEl = wrapper.querySelector('.swiper-button-next');
      const prevEl = wrapper.querySelector('.swiper-button-prev');

      // Configuración de Swiper usando elementos directos
      const swiperConfig = {
        direction: 'horizontal',
        loop: config.loop,
        speed: config.transitionSpeed,
        effect: config.effect,
        slidesPerView: 1,
        watchSlidesProgress: true,
        autoplay: config.autoplay ? { 
          delay: config.autoplaySpeed, 
          disableOnInteraction: false 
        } : false
      };

      // Solo agregar pagination si el elemento existe y está configurado (desktop O mobile)
      if ((config.showBullets || config.showBulletsMobile) && paginationEl) {
        swiperConfig.pagination = {
          el: paginationEl,
          clickable: true
        };
      }

      // Solo agregar navigation si los elementos existen y está configurado (desktop O mobile)
      if ((config.showArrows || config.showArrowsMobile) && nextEl && prevEl) {
        swiperConfig.navigation = {
          nextEl: nextEl,
          prevEl: prevEl
        };
      }

      // Eventos de Swiper
      swiperConfig.on = {
        init: function() {
          // Asegurar que empiece en el primer slide
          if (this.slides && this.slides.length > 0 && !config.loop) {
            this.slideTo(0, 0);
          }
        }
      };

      // Inicializar Swiper
      const swiper = new Swiper(swiperEl, swiperConfig);

      swiperEl.swiper = swiper;

      window.addEventListener('resize', debounce(function () { 
        applyMobileOverrides(wrapper); 
        if (swiper && swiper.update) swiper.update(); 
      }, 200));
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { loadSwiperFromCDN().then(initSlideshows).catch(() => {}); }); else loadSwiperFromCDN().then(initSlideshows).catch(() => {});

  window.reinitJamSlideshows = initSlideshows;
})();

